import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonSelect from "../../../components/forms/CommonSelect";
import CommonInput from "../../../components/forms/CommonInput";
import CommonTextArea from "../../../components/forms/CommonTextArea";
import { handleChange } from "../../../helpers/handleFormChanges";
import PropTypes from "prop-types";

function ModeloModal({
  isOpen,
  setIsOpen,
  valuesHook,
  salvaNovoModelo,
  novo,
  salvaModelo,
}) {
  const { values, setValues } = valuesHook;

  return (
    <CommonModal
      title={novo ? "Novo modelo" : "Editar modelo"}
      is_open_modal={isOpen}
      set_is_open_modal={setIsOpen}
      size="lg"
      buttons={
        novo ? (
          <CommonButton
            onClick={() => {
              salvaNovoModelo();
            }}
            color="success"
          >
            Cadastrar
          </CommonButton>
        ) : (
          <CommonButton
            onClick={() => {
              salvaModelo();
            }}
            color="success"
          >
            Salvar
          </CommonButton>
        )
      }
    >
      <div className="row">
        <div className="col-md-4 mb-3">
          <CommonSelect
            label="Tipo de modelo"
            id="tipo"
            value={values.tipo}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            data={[{ id: "1", text: "WhatsApp" }]}
            placeholder="Selecione um tipo"
            required
          />
        </div>
        <div className="col-md-5 mb-3">
          <CommonInput
            label="Nome do modelo"
            id="nome"
            value={values.nome}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
          />
        </div>
        <div className="col-md-3 mb-3">
          <CommonSelect
            label="Variáveis"
            id="variaveis"
            value={values.variaveis}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            data={[
              { id: "0", text: "0" },
              { id: "1", text: "1" },
              { id: "2", text: "2" },
              { id: "3", text: "3" },
              { id: "4", text: "4" },
            ]}
            placeholder="Selecione a quantidade"
            required
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12 mb-3">
          <CommonTextArea
            label="Descrição do modelo"
            id="descricao"
            value={values.descricao}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            rows={3}
            maxLength={1024}
            required
          />
        </div>
      </div>
    </CommonModal>
  );
}

ModeloModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  salvaNovoModelo: PropTypes.func.isRequired,
  novo: PropTypes.bool.isRequired,
  salvaModelo: PropTypes.func.isRequired,
};

export default ModeloModal;
